import {lazy} from '@aboutyou/lazy-imports';

export const ProductDetailsReviewsSectionView = lazy(() =>
  import('./ProductDetailsReviewsSectionView.eager').then(mod => ({
    default: mod.ProductDetailsReviewsSectionView,
  })),
);
